// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2v628","colBig":"styles_colBig__3It89","colSmall":"styles_colSmall__2eS6x"};